import React from "react";
import "animate.css";

function Endusertraining() {
  return (
    <>
      {/* Responsive Image Styling */}
      <style>
        {`
          @media (max-width: 768px) {
            .sap-support-img {
              max-height: 350px !important;
            }
          }
        `}
      </style>

      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb5">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            End User Training
          </h4>
        </div>
      </div>

      {/* Main Content Start */}
      <div className="container py-5">

        {/* Section 1: ERP Support Models Overview */}
        <section className="wow fadeInUp" data-wow-delay="0.2s">
          <div className="row align-items-center mb-5">
            <div className="col-lg-6 d-flex justify-content-center">
              <img
                src="https://images.pexels.com/photos/1181315/pexels-photo-1181315.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="ERP Support Models"
                className="img-fluid rounded-4 shadow-lg sap-support-img"
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </div>
            <div className="col-lg-6">
              <div className="section-title">
                <h2>End User Training</h2>
                <p>
                  Empowers employees with the skills and knowledge to effectively use SAP systems.
                  Benefits: Increased user adoption, reduced errors, improved productivity,
                  confidence in system usage, and smoother transitions during SAP implementations.

                </p>
                
                
                
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>
    </>
  );
}

export default Endusertraining;
